export const runbookStepConstants = {
  GET_REQUEST: "GET_RUNBOOKSTEP_REQUEST",
  GET_SUCCESS: "GET_RUNBOOKSTEP_SUCCESS",
  GET_FAILURE: "GET_RUNBOOKSTEP_FAILURE",
  ADD_BLANK_REQUEST: "ADD_BLANK_RUNBOOKSTEP_REQUEST",
  ADD_BLANK_SUCCESS: "ADD_BLANK_RUNBOOKSTEP_SUCCESS",
  ADD_BLANK_FAILURE: "ADD_BLANK_RUNBOOKSTEP_FAILURE",
  ADD_FORLOOPENDLOOP_REQUEST: "ADD_FORLOOPENDLOOP_RUNBOOKSTEP_REQUEST",
  ADD_FORLOOPENDLOOP_SUCCESS: "ADD_FORLOOPENDLOOP_RUNBOOKSTEP_SUCCESS",
  ADD_FORLOOPENDLOOP_FAILURE: "ADD_FORLOOPENDLOOP_RUNBOOKSTEP_FAILURE",
  ADD_AFTER_REQUEST: "ADD_AFTER_RUNBOOKSTEP_REQUEST",
  ADD_AFTER_SUCCESS: "ADD_AFTER_RUNBOOKSTEP_SUCCESS",
  ADD_AFTER_FAILURE: "ADD_AFTER_RUNBOOKSTEP_FAILURE",
  ADD_BEFORE_REQUEST: "ADD_BEFORE_RUNBOOKSTEP_REQUEST",
  ADD_BEFORE_SUCCESS: "ADD_BEFORE_RUNBOOKSTEP_SUCCESS",
  ADD_BEFORE_FAILURE: "ADD_BEFORE_RUNBOOKSTEP_FAILURE",
  ADD_TRUE_REQUEST: "ADD_TRUE_RUNBOOKSTEP_REQUEST",
  ADD_TRUE_SUCCESS: "ADD_TRUE_RUNBOOKSTEP_SUCCESS",
  ADD_TRUE_FAILURE: "ADD_TRUE_RUNBOOKSTEP_FAILURE",
  ADD_FALSE_REQUEST: "ADD_FALSE_RUNBOOKSTEP_REQUEST",
  ADD_FALSE_SUCCESS: "ADD_FALSE_RUNBOOKSTEP_SUCCESS",
  ADD_FALSE_FAILURE: "ADD_FALSE_RUNBOOKSTEP_FAILURE",
  DELETE_REQUEST: "DELETE_RUNBOOKSTEP_REQUEST",
  DELETE_SUCCESS: "DELETE_RUNBOOKSTEP_SUCCESS",
  DELETE_FAILURE: "DELETE_RUNBOOKSTEP_FAILURE",
  UPDATE_REQUEST: "UPDATE_RUNBOOKSTEP_REQUEST",
  UPDATE_SUCCESS: "UPDATE_RUNBOOKSTEP_SUCCESS",
  UPDATE_FAILURE: "UPDATE_RUNBOOKSTEP_FAILURE",
  GET_ALL_ACTIONS_REQUEST: "GET_ALL_ACTIONS_REQUEST",
  GET_ALL_ACTIONS_SUCCESS: "GET_ALL_ACTIONS_SUCCESS",
  GET_ALL_ACTIONS_FAILURE: "GET_ALL_ACTIONS_FAILURE",
};
